/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type { SerializedListItemNode } from './PhxListItemNode';
import type { ListType, SerializedListNode } from './PhxListNode';
import type { LexicalCommand } from 'lexical';

import { createCommand } from 'lexical';

import { $handleListInsertParagraph, insertList, removeList } from './formatList';
import {
  $createListItemNode,
  $isListItemNode,
  PhxListItemNode,
} from './PhxListItemNode';
import { $createListNode, $isListNode, PhxListNode } from './PhxListNode';
import { $getListDepth } from './utils';

export {
  $createListItemNode,
  $createListNode,
  $getListDepth,
  $handleListInsertParagraph,
  $isListItemNode,
  $isListNode,
  insertList,
  PhxListItemNode,
  PhxListNode,
  ListType,
  removeList,
  SerializedListItemNode,
  SerializedListNode,
};

export const INSERT_UNORDERED_LIST_COMMAND: LexicalCommand<void> =
  createCommand('INSERT_UNORDERED_LIST_COMMAND');
export const INSERT_ORDERED_LIST_COMMAND: LexicalCommand<string> = createCommand(
  'INSERT_ORDERED_LIST_COMMAND',
);
export const INSERT_CHECK_LIST_COMMAND: LexicalCommand<void> = createCommand(
  'INSERT_CHECK_LIST_COMMAND',
);
export const REMOVE_LIST_COMMAND: LexicalCommand<void> = createCommand(
  'REMOVE_LIST_COMMAND',
);
export const CHANGE_LIST_TYPE_COMMAND: LexicalCommand<ListType> = createCommand(
  'CHANGE_LIST_TYPE_COMMAND',
);